import { Divider } from '@mui/material';
import TextField from '@mui/material/TextField';
import { MemreFlexBox } from 'components/core';
import { useAuthoringContext } from 'pages/authoring/AuthoringContext';
import { useState } from 'react';
import { Ratings } from 'services/useItem.service/interactions';
import AttachInstructionalItem from '../components/AttachInstructionalItem';
import RatingHeadings from '../components/RatingHeadings';

export default function RatingsComponent() {
  const rating = useAuthoringContext()?.item as Ratings;
  const [questionText, setQuestionText] = useState(rating.question.text);

  return (
    <MemreFlexBox
      direction="column"
      gap={2}
      sx={{
        p: 2,
        pl: 0,
        width: '100%',
      }}
    >
      <MemreFlexBox direction="row" gap={2}>
        <TextField
          label="Question Text"
          variant="outlined"
          sx={{ flex: 1 }}
          value={questionText}
          onBlur={() => rating.question.update(questionText)}
          onChange={(e) => setQuestionText(e.target.value)}
        />
      </MemreFlexBox>
      <RatingHeadings />

      <Divider sx={{ width: '100%', m: 0.5, mt: 2 }} />
      
      {rating?.id && (
        <AttachInstructionalItem 
          itemId={rating.id}
        />
      )}
    </MemreFlexBox>
  );
}
